import { render, staticRenderFns } from "./ServiceCardUser.vue?vue&type=template&id=7d3b90a2&"
import script from "./ServiceCardUser.vue?vue&type=script&lang=js&"
export * from "./ServiceCardUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports